import { render, staticRenderFns } from "./BandeiraMaster.vue?vue&type=template&id=9db9111a&"
import script from "./BandeiraMaster.vue?vue&type=script&lang=js&"
export * from "./BandeiraMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports